import { Layout } from 'antd'
import scrollTo from 'antd/lib/_util/scrollTo'
import React, { FunctionComponent, ReactNode } from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'
import Footer from '@/components/common/footer'
import { Header } from '@/components/layout/header'
import useHeaderHeight from '@/hooks/use-header-height'

interface KolDetailLayoutProps {
  children?: ReactNode
}

export const KolDetailLayout: FunctionComponent<KolDetailLayoutProps> = (
  props,
) => {
  const headerHeight = useHeaderHeight()
  useMount(() => {
    scrollTo(0)
  })

  return (
    <Layout>
      <Header />
      <ContentWrapper headerHeight={headerHeight}>
        {props.children}
      </ContentWrapper>
      <Footer />
    </Layout>
  )
}

export const ContentWrapper = styled.div<{ headerHeight: number }>`
  margin-top: ${({ headerHeight }): number => headerHeight}px;
`
